import React from 'react'
import './testemonal.css'
import avt1 from './images/test3.jpg';
import avt2 from './images/testi2.jpg'
import avt3 from './images/testimon.jpg'
import avt4 from './images/mess.jpg'
import avt5 from './images/img5.jpg'
import avt6 from './images/img.jpg'
import avt7 from './images/mihiiret.jpg'
import avt8 from './images/j.png'
// import Review from './trial'
import  { useRef, useState, useEffect,useContext } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";
import {fetchReviews } from "./trial";
import { Pagination, Navigation } from "swiper";



// import { fetchReviews } from "./trial";

// let reviewsArray =[]; // Declare a variable outside of the function

// const getReviews = async () => {
//   try {
//     reviewsArray = await fetchReviews(); // Assign the resolved reviewsArray to the variable
//     // console.log("insde",reviewsArray[0]);
//     // Access the first element of the array
//   } catch (error) {
//     console.error(error);
//   }
// };


// getReviews().then(() => {
//   data[0].review = reviewsArray[0];
//   console.log("the",data[6].review);
// });





const data =[
  {

  id :1,
  avator:avt1,
  Name:"Melaku Abebe",
  review:`I've had the pleasure of working with Mehari on several key projects over the years, and he've blown me away each time. his full-stack development expertise is head and shoulders above others I've seen in this field. He bring a wealth of experience and knowledge to the table and can handle any challenge thrown their way. They make it look effortless, and their attention to detail is unparalleled.`,
 
  position:`Software engineer working @ A2SV as assistant`
},

{

  id :3,
  avator:avt2,
  Name:'Matiyas Seifu',
  review:`I brought Mehari onboard when I needed some extra hands-on-deck for a complex web project. In relatively no time, he got their head down and produced high-quality, custom code across the entire stack - from UI/UX design to server configuration.  He also showed strong technical leadership, prioritizing functionality and performance, while providing excellent guidance and communication to our team. We couldn't have done it without him`,

  position:`Software engineer `
},

{

  id :5,
  avator:avt3,
  Name:"Matiyas Yohhannes",
  review:`Mehari is a highly skilled programmer who I have worked with on several projects using MERN STACK. He is always willing to share his knowledge and help his teammates. His attention to detail and problem-solving skills are impressive. It has been a great learning experience working with him.`,

  position:`Software engineer working @ A2SV as assistant`
},
{

  id :7,
  avator:avt5,
  Name:"Eshetu Grimma",
  review:`I   and Mehari  learned competitive programming together and worked on many projects. Their combined skills and dedication have always delivered excellent results. It has been a pleasure working with him, and I look forward to working with him again in the future`,

  position:`Electrical Engineer`
},

{

  id :9,
  avator:avt4,
  Name:"Mesekir Getachew",
  review:`I have had the pleasure of mentoring Mehari in their journey as a competitive programmer, and I can confidently say that they are one of the most talented individuals I have ever worked with. His determination and problem-solving skills are second to none, and they continually push themselves to be better`,
 
  position:`Software engineer`

},
{

  id :11,
  avator:avt8,
  Name:"Jimma Dubbe",
  review:`As I am  a highly skilled front-end developer who I had the pleasure of working with on projects using React. Mehari Tesfaye was also part of the team, and together we delivered excellent results. His attention to detail and problem-solving skills are impressive, and he is a great team player.`,
 
  position:`Software engineer`

},
{

  id :13,
  avator:avt7,
  Name:"Mihiret Tibebe",
  review:`Mehari  is an exceptional programmer and a great team player. We have worked on many group projects using PHP, MYSQL, HTML, and CSS and many more technologies. His attention to detail and problem-solving skills make him a valuable asset to any team. It has been a pleasure working with him.`,
 
  position:`Software engineer`

}
// {id : 6,
//   review:"not loadd"

//   }


]
async function main() {
  try {
    const reviews = await fetchReviews();
    data.splice(0, 0, { review: reviews[2], avator: avt6,id:0 });
    data.splice(2, 0, { review: reviews[1], avator: avt6,id:2 });
    data.splice(4, 0, { review: reviews[3], avator: avt6,id:4 });
    data.splice(6, 0, { review: reviews[4], avator: avt6,id:6 });
    // data.splice(8, 0, { review: reviews[6], avator: avt6 });
    // data.push({ review: reviews[5],avator:avt6 }, { review: reviews[2],avator:avt6 },{ review: reviews[2],avator:avt6 }, { review: reviews[4],avator:avt6 })
    console.log("data",data);
  } catch (error) {
    console.error(error.message);
  }
}
main();

function Slideshow({ testimonial, setTestimonial, handleTouchStart, handleTouchEnd }) {

  
  const swiperRef = useRef(null);
  const intervalRef = useRef(null);

  const handleSlideChange = () => {
    if (swiperRef.current) {
      const { activeIndex } = swiperRef.current;
      setTestimonial(activeIndex);
    }
  };





  

  useEffect(() => {
    intervalRef.current = setInterval(() => {
      if (swiperRef.current) {
        const { isEnd } = swiperRef.current;
        if (isEnd) {
          swiperRef.current.slideTo(0);
        } else {
          swiperRef.current.slideNext();
        }
      }
    }, 15000);

    return () => clearInterval(intervalRef.current);
  }, []);

  const handleTouchStartLocal = () => {
    if (handleTouchStart) {
      handleTouchStart();
    }
    clearInterval(intervalRef.current);
  };

  const handleTouchEndLocal = () => {
    if (handleTouchEnd) {
      handleTouchEnd();
    }
    intervalRef.current = setInterval(() => {
      if (swiperRef.current) {
        const { isEnd } = swiperRef.current;
        if (isEnd) {
          swiperRef.current.slideTo(0);
        } else {
          swiperRef.current.slideNext();
        }
      }
    }, 15000);
  };

  return (
    <Swiper
      pagination={{
        type: "progressbar",
      }}
      navigation={true}
      modules={[Pagination, Navigation]}
      className="mySwiper container testimonials_container"
      initialSlide={testimonial}
      effect={"fade"}
      loop={true}
      onSwiper={(swiper) => (swiperRef.current = swiper)}
      onSlideChange={handleSlideChange}
      onTouchStart={handleTouchStartLocal}
      onTouchEnd={handleTouchEndLocal}
      onMouseEnter={handleTouchStartLocal}
      onMouseLeave={handleTouchEndLocal}
    >
    {data.map(({ id, avator, Name, review }) => (
  <SwiperSlide key={id} className="testimonial">
    <div>
      
    <div className={id % 2 === 0 ? "avatar1" : "client_avatar_container"}>
  <img src={avator} className="client_avatar" alt={Name} />
</div>
     
      <h5 className="client_name">{Name}</h5>
      <small className="client_review">{review}</small>
      {/* <Review/> */}
    </div>
  </SwiperSlide>
))}
    </Swiper>
  );
}

export const Testimonial = () => {
  const [testimonial, setTestimonial] = useState(0);

  const handleTouchStart = () => {
    console.log("Touch started");
  };

  const handleTouchEnd = () => {
    console.log("Touch ended");
  };

  return (
    <section>
      <h5>Review from clients</h5>
      <h2>Testimonials</h2>
      <Slideshow
        testimonial={testimonial}
        setTestimonial={setTestimonial}
        handleTouchStart={handleTouchStart}
        handleTouchEnd={handleTouchEnd}
      />
      {/* <Trial /> */}
      
    </section>
  );
};
